import { render, staticRenderFns } from "./UserPrimaryColor.vue?vue&type=template&id=7d7b0659&scoped=true"
import script from "./UserPrimaryColor.vue?vue&type=script&lang=ts"
export * from "./UserPrimaryColor.vue?vue&type=script&lang=ts"
import style0 from "./UserPrimaryColor.vue?vue&type=style&index=0&id=7d7b0659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b0659",
  null
  
)

export default component.exports